import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import { Tabs } from '@mui/base/Tabs';
import { TabsList as TabsListBase } from '@mui/base/TabsList';
import { TabPanel as TabPanelBase } from '@mui/base/TabPanel';
import { Tab as TabBase } from '@mui/base/Tab';
import useLocalStorageState from '@mui/utils/useLocalStorageState';
import { HighlightedCode } from '../HighlightedCode';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PACKAGE_MANAGER_ORDER = new Map(['npm', 'pnpm', 'yarn'].map(function (manager, index) {
  return [manager, index];
}));
export var CodeTabList = styled(TabsListBase)(function (_ref) {
  var theme = _ref.theme;
  return _extends({
    display: 'flex',
    gap: theme.spacing(0.5),
    borderLeft: '1px solid',
    borderRight: '1px solid',
    overflowX: 'auto'
  }, theme.applyDarkStyles({
    backgroundColor: alpha(theme.palette.primaryDark[800], 0.2)
  }), {
    variants: [{
      props: function props(_ref2) {
        var ownerState = _ref2.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        padding: theme.spacing(1.5, 1)
      }
    }, {
      props: function props(_ref3) {
        var ownerState = _ref3.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        padding: theme.spacing(1)
      }
    }, {
      props: function props(_ref4) {
        var ownerState = _ref4.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        borderTop: 'none'
      }
    }, {
      props: function props(_ref5) {
        var ownerState = _ref5.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        borderTop: '1px solid'
      }
    }, {
      props: function props(_ref6) {
        var ownerState = _ref6.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        borderBottom: 'none'
      }
    }, {
      props: function props(_ref7) {
        var ownerState = _ref7.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        borderBottom: '1px solid'
      }
    }, {
      props: function props(_ref8) {
        var ownerState = _ref8.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        borderTopLeftRadius: 0
      }
    }, {
      props: function props(_ref9) {
        var ownerState = _ref9.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius
      }
    }, {
      props: function props(_ref10) {
        var ownerState = _ref10.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        borderTopRightRadius: 0
      }
    }, {
      props: function props(_ref11) {
        var ownerState = _ref11.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
      }
    }, {
      props: function props(_ref12) {
        var ownerState = _ref12.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        borderColor: (theme.vars || theme).palette.divider
      }
    }, {
      props: function props(_ref13) {
        var ownerState = _ref13.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        borderColor: (theme.vars || theme).palette.primaryDark[700]
      }
    }, {
      props: function props(_ref14) {
        var ownerState = _ref14.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        backgroundColor: alpha(theme.palette.grey[50], 0.2)
      }
    }, {
      props: function props(_ref15) {
        var ownerState = _ref15.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        backgroundColor: (theme.vars || theme).palette.primaryDark[900]
      }
    }]
  });
});
export var CodeTabPanel = styled(TabPanelBase)({
  '& pre': {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    '& code': {}
  },
  variants: [{
    props: function props(_ref16) {
      var ownerState = _ref16.ownerState;
      return ownerState == null ? void 0 : ownerState.contained;
    },
    style: {
      marginTop: -1
    }
  }, {
    props: function props(_ref17) {
      var ownerState = _ref17.ownerState;
      return !(ownerState != null && ownerState.contained);
    },
    style: {
      marginTop: 0
    }
  }, {
    props: function props(_ref18) {
      var ownerState = _ref18.ownerState;
      return ownerState == null ? void 0 : ownerState.contained;
    },
    style: {
      '& pre': {
        marginTop: 0
      }
    }
  }, {
    props: function props(_ref19) {
      var ownerState = _ref19.ownerState;
      return !(ownerState != null && ownerState.contained);
    },
    style: {
      '& pre': {
        marginTop: -1
      }
    }
  }, {
    props: function props(_ref20) {
      var ownerState = _ref20.ownerState;
      return ownerState.mounted;
    },
    style: {
      '& pre': {
        '& code': {
          opacity: 1
        }
      }
    }
  }, {
    props: function props(_ref21) {
      var ownerState = _ref21.ownerState;
      return !ownerState.mounted;
    },
    style: {
      '& pre': {
        '& code': {
          opacity: 0
        }
      }
    }
  }]
});
export var CodeTab = styled(TabBase)(function (_ref22) {
  var theme = _ref22.theme;
  return _extends({
    variants: [{
      props: function props(_ref23) {
        var ownerState = _ref23.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        border: '1px solid transparent',
        fontSize: theme.typography.pxToRem(13)
      }
    }, {
      props: function props(_ref24) {
        var ownerState = _ref24.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        border: 'none',
        fontSize: theme.typography.pxToRem(12)
      }
    }, {
      props: function props(_ref25) {
        var ownerState = _ref25.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        color: (theme.vars || theme).palette.text.tertiary
      }
    }, {
      props: function props(_ref26) {
        var ownerState = _ref26.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        color: (theme.vars || theme).palette.grey[500]
      }
    }, {
      props: function props(_ref27) {
        var ownerState = _ref27.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        fontFamily: theme.typography.fontFamily
      }
    }, {
      props: function props(_ref28) {
        var ownerState = _ref28.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        fontFamily: theme.typography.fontFamilyCode
      }
    }, {
      props: function props(_ref29) {
        var ownerState = _ref29.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        fontWeight: theme.typography.fontWeightMedium
      }
    }, {
      props: function props(_ref30) {
        var ownerState = _ref30.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        fontWeight: theme.typography.fontWeightBold
      }
    }, {
      props: function props(_ref31) {
        var ownerState = _ref31.ownerState;
        return ownerState == null ? void 0 : ownerState.contained;
      },
      style: {
        transition: 'background, color, 100ms ease'
      }
    }, {
      props: function props(_ref32) {
        var ownerState = _ref32.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        transition: 'unset'
      }
    }, {
      props: function props(_ref33) {
        var ownerState = _ref33.ownerState;
        return !(ownerState != null && ownerState.contained);
      },
      style: {
        '&:hover': {
          backgroundColor: alpha(theme.palette.primaryDark[500], 0.5),
          color: (theme.vars || theme).palette.grey[400]
        }
      }
    }, {
      props: function props(_ref34) {
        var ownerState = _ref34.ownerState;
        return !(ownerState != null && ownerState.contained) && ownerState.mounted;
      },
      style: {
        '&.base--selected': {
          color: '#FFF',
          '&::after': {
            content: "''",
            position: 'absolute',
            left: 0,
            bottom: '-8px',
            height: 2,
            width: '100%',
            bgcolor: (theme.vars || theme).palette.primary.light
          }
        }
      }
    }]
  }, theme.unstable_sx({
    flex: '0 0 auto',
    height: 26,
    p: '2px 8px',
    bgcolor: 'transparent',
    lineHeight: 1.2,
    outline: 'none',
    minWidth: 45,
    cursor: 'pointer',
    borderRadius: 99,
    position: 'relative',
    '&:hover': {
      backgroundColor: (theme.vars || theme).palette.divider
    },
    '&:focus-visible': {
      outline: '3px solid',
      outlineOffset: '1px',
      outlineColor: (theme.vars || theme).palette.primary.light
    }
  }));
});
export function HighlightedCodeWithTabs(props) {
  var tabs = props.tabs,
    storageKey = props.storageKey;
  var availableTabs = React.useMemo(function () {
    var result = tabs.map(function (_ref35) {
      var tab = _ref35.tab;
      return tab;
    });
    if (storageKey === 'package-manager') {
      result.sort(function (a, b) {
        var _PACKAGE_MANAGER_ORDE, _PACKAGE_MANAGER_ORDE2;
        return ((_PACKAGE_MANAGER_ORDE = PACKAGE_MANAGER_ORDER.get(a)) != null ? _PACKAGE_MANAGER_ORDE : Infinity) - ((_PACKAGE_MANAGER_ORDE2 = PACKAGE_MANAGER_ORDER.get(b)) != null ? _PACKAGE_MANAGER_ORDE2 : Infinity);
      });
    }
    return result;
  }, [storageKey, tabs]);
  var _useLocalStorageState = useLocalStorageState(storageKey != null ? storageKey : null, availableTabs[0]),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    activeTab = _useLocalStorageState2[0],
    setActiveTab = _useLocalStorageState2[1];
  // During hydration, activeTab is null, default to first value.
  var defaultizedActiveTab = activeTab != null ? activeTab : availableTabs[0];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mounted = _React$useState2[0],
    setMounted = _React$useState2[1];
  React.useEffect(function () {
    setMounted(true);
  }, []);
  var handleChange = function handleChange(event, newValue) {
    setActiveTab(newValue);
  };
  var ownerState = {
    mounted: mounted
  };
  return /*#__PURE__*/_jsxs(Tabs, {
    selectionFollowsFocus: true,
    value: defaultizedActiveTab,
    onChange: handleChange,
    children: [/*#__PURE__*/_jsx(CodeTabList, {
      ownerState: ownerState,
      children: tabs.map(function (_ref36) {
        var tab = _ref36.tab;
        return /*#__PURE__*/_jsx(CodeTab, {
          ownerState: ownerState,
          value: tab,
          children: tab
        }, tab);
      })
    }), tabs.map(function (_ref37) {
      var tab = _ref37.tab,
        language = _ref37.language,
        code = _ref37.code;
      return /*#__PURE__*/_jsx(CodeTabPanel, {
        ownerState: ownerState,
        value: tab,
        children: /*#__PURE__*/_jsx(HighlightedCode, {
          language: language || 'bash',
          code: typeof code === 'function' ? code(tab) : code
        })
      }, tab);
    })]
  });
}